import { Menu } from '@headlessui/react';
import { ChevronDownIcon } from '@icons';
import clsx from 'clsx';
import { ReactNode } from 'react';

interface DropdownProps {
	children: ReactNode;
	placeholder: string;
	value?: string;
	align?: 'left' | 'right';
	label?: string;
	menuDataTestId?: string;
}

export const Dropdown = ({
	children,
	placeholder,
	align = 'left',
	label,
	menuDataTestId
}: DropdownProps) => {
	return (
		<div className="flex flex-col gap-2">
			<label className="text-sm font-medium text-gray-700">{label}</label>

			<Menu as="div" className="relative">
				<Menu.Button
					className="flex gap-2 items-center px-4 h-[40px] rounded-md border border-gray-500"
					data-testid={menuDataTestId}
				>
					<span className="flex-1 text-base text-gray-700">{placeholder}</span>

					<ChevronDownIcon className="text-icon-base" />
				</Menu.Button>

				<Menu.Items
					className={clsx(
						'absolute flex flex-col mt-2 rounded-md overflow-hidden bg-white min-w-40 shadow-[0_4px_12px_0_rgba(0,0,0,0.15)] focus:outline-none transition duration-100 ease-out data-[closed]:scale-95 data-[closed]:opacity-0 z-50',
						align === 'right' && 'right-0 origin-top-right',
						align === 'left' && 'left-0 origin-top-left'
					)}
				>
					{children}
				</Menu.Items>
			</Menu>
		</div>
	);
};

interface DropdownItemProps {
	children: ReactNode;
	onClick?: () => void;
	className?: string;
}

Dropdown.Item = ({ children, onClick, className }: DropdownItemProps) => {
	return (
		<Menu.Item>
			{({ active }) => (
				<button
					type="button"
					onClick={onClick}
					className={clsx(
						'text-start px-4 py-2 text-base',
						active && 'bg-primary-500 text-white',
						!active && 'text-gray-900',
						className
					)}
				>
					{children}
				</button>
			)}
		</Menu.Item>
	);
};
